import { render } from "./FrequentlyPurchased.vue?vue&type=template&id=973b6ba6&scoped=true"
import script from "./FrequentlyPurchased.vue?vue&type=script&lang=js"
export * from "./FrequentlyPurchased.vue?vue&type=script&lang=js"

import "./FrequentlyPurchased.vue?vue&type=style&index=0&id=973b6ba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-973b6ba6"]])

export default __exports__